import { Helmet } from "react-helmet-async";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";

const Rodo = () => (
  <div className="min-h-screen bg-background">
    <Helmet>
      <title>Obowiązek informacyjny RODO | WystepKabaretu.pl</title>
      <meta name="description" content="Obowiązek informacyjny RODO - informacje o przetwarzaniu danych osobowych przez WystepKabaretu.pl zgodnie z RODO." />
      <link rel="canonical" href="https://wystepkabaretu.pl/rodo" />
      <meta name="robots" content="index, follow" />
    </Helmet>
    <Navigation />
    <main className="container max-w-3xl py-16 px-4 pt-28">
      <h1 className="text-4xl font-montserrat font-black text-foreground mb-8">Obowiązek informacyjny RODO</h1>

      <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
        <p>Zgodnie z art. 13 ust. 1 i 2 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. (RODO), informujemy że:</p>

        <h2 className="text-xl font-bold text-foreground mt-8">1. Administrator danych osobowych</h2>
        <p>Administratorem Państwa danych osobowych jest Wirtualny Biznes z siedzibą przy ul. Księcia Witolda 49/15, 50-202 Wrocław, NIP: 8961619199.</p>

        <h2 className="text-xl font-bold text-foreground mt-8">2. Cel przetwarzania danych</h2>
        <p>Państwa dane osobowe przetwarzane są w celu:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Realizacji zapytań przesłanych za pośrednictwem formularza kontaktowego (art. 6 ust. 1 lit. b RODO)</li>
          <li>Przedstawienia oferty usług kabaretowych (art. 6 ust. 1 lit. a RODO)</li>
          <li>Wypełnienia obowiązków prawnych ciążących na administratorze (art. 6 ust. 1 lit. c RODO)</li>
          <li>Realizacji prawnie uzasadnionych interesów administratora (art. 6 ust. 1 lit. f RODO)</li>
        </ul>

        <h2 className="text-xl font-bold text-foreground mt-8">3. Odbiorcy danych</h2>
        <p>Dane osobowe mogą być przekazywane podmiotom przetwarzającym dane na zlecenie administratora, w tym dostawcom usług IT, hostingowych i pocztowych.</p>

        <h2 className="text-xl font-bold text-foreground mt-8">4. Okres przechowywania danych</h2>
        <p>Dane osobowe będą przechowywane przez okres niezbędny do realizacji celów przetwarzania, nie dłużej niż wynika to z przepisów prawa lub do momentu wycofania zgody.</p>

        <h2 className="text-xl font-bold text-foreground mt-8">5. Prawa osób, których dane dotyczą</h2>
        <p>Przysługuje Państwu prawo do:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Dostępu do swoich danych osobowych</li>
          <li>Sprostowania danych osobowych</li>
          <li>Usunięcia danych osobowych</li>
          <li>Ograniczenia przetwarzania danych osobowych</li>
          <li>Przenoszenia danych osobowych</li>
          <li>Wniesienia sprzeciwu wobec przetwarzania</li>
          <li>Cofnięcia zgody w dowolnym momencie</li>
        </ul>

        <h2 className="text-xl font-bold text-foreground mt-8">6. Prawo do wniesienia skargi</h2>
        <p>Przysługuje Państwu prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych (ul. Stawki 2, 00-193 Warszawa).</p>

        <h2 className="text-xl font-bold text-foreground mt-8">7. Kontakt</h2>
        <p>W sprawach dotyczących przetwarzania danych osobowych prosimy o kontakt pod adresem e-mail: <a href="mailto:kontakt@wystepkabaretu.pl" className="text-accent hover:underline">kontakt@wystepkabaretu.pl</a>.</p>
      </div>
    </main>
    <Footer />
  </div>
);

export default Rodo;
